<mat-form-field [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <mat-select [value]="value" (selectionChange)="onSelectionChange($event?.value);" [disabled]="disabled" [required]="required">
    <mat-optgroup *ngFor="let optgroup of options" [label]="optgroup?.label" [disabled]="optgroup?.disabled ?? null">
      <mat-option *ngFor="let item of optgroup?.group" [value]="item?.value">
        {{ item?.name }}
      </mat-option>
    </mat-optgroup>
  </mat-select>
  <ng-content select="[validation]"></ng-content>
  <ng-container *ngIf="validator && formSubmit">
    <ng-container *ngFor="let error of formControl?.errors | keyvalue;">
      <mat-error *ngIf="error?.value">
        <em class="fas fa-exclamation-circle mr-2"></em>
        {{ generalService?.getErrorMessage(label, error?.key) }}
      </mat-error>
    </ng-container>
  </ng-container>
</mat-form-field>